import { createSelector } from "reselect";
import { getUserData } from "./user";
import Environment from "utils/Environment";

export const checkPreloaderShown = ({ ui: { preloaderShown } }) => preloaderShown;

export const checkPreloaderOverlayShown = ({ ui: { preloaderOverlayShown } }) => preloaderOverlayShown;

export const checkModalContentShown = ({ ui: { modalContentShown } }) => modalContentShown;

export const checkExperimentalFeatureAllowed = createSelector(
  [getUserData],
  ({ superAdmin }) => !Environment.checkIsProductionEnv() || superAdmin
);

export const getModalWindowConfig = ({ ui: { modalWindowConfig } }) => modalWindowConfig;

export const getPreloaderText = ({ ui: { preloaderText } }) => preloaderText;

export const getModalImages = ({ ui: { modalImages } }) => modalImages;

export const getOpenedModalsData = ({ ui: { openedModals } }) => openedModals;
